import { Component, OnDestroy, OnInit } from '@angular/core';
import { SeminarPageService } from '../../shared/services/seminar-page.service';
import { getReturnCase, getReturnCaseEnd } from '../../shared/utils/resourceUtils';
import { DomSanitizer, SafeHtml, Title } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { requestDynaimicPagePayload, requestWholesalerInfoPlayload } from '../../shared/models/model';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { FooterService } from '../../shared/services/footer.service';
import { WholesalerInfoService } from '../../shared/services/wholesaler.service';

@Component({
  selector: 'app-dynamic-page-loader',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dynamic-page-loader.component.html',
  styleUrls: ['./dynamic-page-loader.component.scss'],
})
export class DynamicPageLoaderComponent implements OnInit, OnDestroy {
  public htmlContents: string = '';
  seminarPageData: any;
  public dynamicPageName: string = 'seminars';
  path: string = '';
  pageNum = 0;
  errorMessage: string = '';
  hasWholesalerInfo: boolean = false;
  wholesalerInfo: any = {};
  isshowMoreButton: boolean = false;
  isToShowList: boolean = true;
  public routeSub: Subscription | undefined; // To store the subscription
  seminarPageSubscription: Subscription = new Subscription();
  wholeSalerInfoSubscription: Subscription = new Subscription();
  constructor(
    private _seminarPageService: SeminarPageService,
    private _footerService: FooterService,
    private _sanitizer: DomSanitizer,
    private _titleService: Title,
    private _activatedRoute: ActivatedRoute,
    private _wholeSalerService: WholesalerInfoService,
  ) {}
  // Method to get seminar page data
  ngOnInit(): void {
    // Get the 'str' parameter from the route
    this.routeSub = this._activatedRoute.url.subscribe((segments) => {
      // Combine path segments
      const seg_path = segments.map((segment) => segment.path).join('/');
      this.path = `/${seg_path}`;
      if (this.path.includes('/advisor/resources')) {
        this.pageNum = 0;
      } else if (this.path.includes('/advisor/promos')) {
        this.pageNum = 1;
      }

      this.htmlContents = '';
      this.getWholesalerInfo();
      setTimeout(() => {
        this.loadPageData();
      }, 500);
    });
  }

  loadPageData(): void {
    this.isshowMoreButton = false;
    this.htmlContents = '';
    setTimeout(() => {
      const payLoad: requestDynaimicPagePayload = {
        requestingSystem: 'FinPro',
        path: this.path,
        page: this.pageNum,
      };
      this.seminarPageSubscription = this._seminarPageService.getSeminarPageData(payLoad)?.subscribe((_data) => {
        this.seminarPageData = _data.content;
        this.setFooterDiscl_compl_Id(this.seminarPageData.disclosureText, this.seminarPageData.complianceId);
        this._titleService.setTitle(this.seminarPageData?.title);
        this.seminarPageData.components.forEach((component: any) => {
          if (component.componentType === 'RichTextCollection') {
            this.createRichTextContent(component);
          } else if (component.componentType === 'StaticResourceListing') {
            this.displayStaticResourceListing(component);
          } else {
            this.htmlContents += getReturnCase(component.componentType);
            component.entries.forEach((entry: any) => {
              this.htmlContents += getReturnCase(entry.componentType);
              if (entry.componentType === 'RichText') {
                this.htmlContents += getReturnCase('RichText');
                this.htmlContents += entry.text;
                this.htmlContents += getReturnCaseEnd('RichText');
              } else if (entry.componentType === 'Image') {
                this.displayImageComponent(entry);
              } else if (entry.componentType === 'PageHeader') {
                this.displayPageHeaderComponent();
              } else if (entry.componentType === 'IFrame') {
                this.displayIframeComponent(entry);
              } else if (entry.componentType === 'AdvisorWholesalers') {
                this.displayAdvisorWholeSaler();
              }
              this.htmlContents += getReturnCaseEnd(entry.componentType);
            });
            this.htmlContents += getReturnCaseEnd(component.componentType);
          }
        });
      });
    }, 200);
  }

  setFooterDiscl_compl_Id(disclosureText: string, complianceId: string) {
    if (disclosureText && disclosureText !== '') {
      this._footerService.setDisclosureText(disclosureText);
    }
    if (complianceId && complianceId !== '') {
      this._footerService.setComplianceID(complianceId);
    }
  }

  //Method for rich text content
  public createRichTextContent(component: any) {
    if (component.hasGrayBackground) {
      this.htmlContents += getReturnCase(component.componentType);
    } else {
      this.htmlContents += getReturnCase('RichTextCollection_noBG');
    }
    if (component.componentType === 'RichTextCollection') {
      let richTextEntryCounter = 0;
      this.htmlContents += getReturnCase('FullWidthContainer');
      if (component.leadingText != null) this.htmlContents += component.leadingText?.text;
      this.htmlContents += getReturnCaseEnd('FullWidthContainer');
      component.entries.forEach((entry: any) => {
        if (richTextEntryCounter === 0) {
          this.htmlContents += getReturnCase('Container 50-50');
        }
        if (richTextEntryCounter < 2) {
          this.htmlContents += getReturnCase('50_50_Col_inside');
          this.htmlContents += entry.text;
          this.htmlContents += getReturnCaseEnd('50_50_Col_inside');
        }
        richTextEntryCounter++;
        if (richTextEntryCounter === 2) {
          this.htmlContents += getReturnCaseEnd('Container 50-50');
          richTextEntryCounter = 0;
        }
      });
      this.htmlContents += getReturnCase('FullWidthContainer');
      if (component.trailingText != null) this.htmlContents += component.trailingText.text;
      this.htmlContents += getReturnCaseEnd('FullWidthContainer');
    }
    if (component.hasGrayBackground) {
      this.htmlContents += getReturnCaseEnd(component.componentType);
    } else {
      this.htmlContents += getReturnCaseEnd('RichTextCollection_noBG');
    }
  }

  //Method to display image components
  displayImageComponent(entry: any) {
    const imgWidth = entry?.width;
    const imgHeight = entry?.height;
    const imageData = `<img alt="Image Placeholder" data-object-fit="cover" width=${imgWidth} height=${imgHeight} class="initial loaded" src=${entry?.url} data-was-processed="true">`;
    this.htmlContents += getReturnCase(entry.componentType);
    this.htmlContents += imageData;
    this.htmlContents += getReturnCaseEnd(entry.componentType);
  }

  //Add page header component
  displayPageHeaderComponent() {
    this.htmlContents += getReturnCase('pageHeader');
    const formattedDate = new Date(this.seminarPageData?.dateOfPublication)
      .toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
      })
      .replace(/\//g, '-');
    this.htmlContents += `${this.seminarPageData?.headerTitle}`;
    if (this.seminarPageData?.dateOfPublication) {
      this.htmlContents += `<div class="dy_fn_page-header__posteddate">${formattedDate}</div>`;
    }
    this.htmlContents += `<div class="dy_fn_page-header__subtitle">${this.seminarPageData?.subtitle ?? ''}</div>`;
    this.htmlContents += getReturnCaseEnd('pageHeader');
  }

  displayIframeComponent(entries: any) {
    const iframeHtml = `<iframe id=${entries?.iFrameId} src=${entries?.source} style="width:${entries?.width} ; height: ${entries?.height}"></iframe>`;
    this.htmlContents += iframeHtml;
  }

  //method for StaticResourceListing component type
  displayStaticResourceListing(comp: any) {
    this.htmlContents += getReturnCase('FullWidthContainer');
    if (comp.heading) {
      this.htmlContents += `<div class="dy_fn_section-heading .dy_fn_resource-listing__heading" role="heading" aria-level="2">${comp.heading}</div>`;
    }
    this.htmlContents += getReturnCase(comp.componentType);
    this.displayStaticResourceListingWithLimit(comp, this.isToShowList);
    comp.entries.forEach((entry: any) => {
      if (entry.componentType === 'StaticResourceIcon') {
        const StaticResourceListingItem = `<a class="dy_finraletters_product-rates__item js-showmore__item" href=${entry.url} target="_blank">
        <div class="dy_finraletters_product-rates__content" tabindex="-1">    
            <span class="dy_finraletters_icon-wrap dy_finraletters_product-rates__icon">
                <img src=${entry.imageUrl} alt="icon"  width="50%">
            </span>    
            <div class="dy_finraletters_product-rates__copy">
                <strong class="dy_finraletters_product-rates__title">${entry.name}&nbsp;&nbsp;<span class="dy_fn_static-resource__icon">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 16.7 16.7" enable-background="new 0 0 16.7 16.7" xml:space="preserve" role="presentation" focusable="false">
                            <path fill="#FFFFFF" fill-opacity="0" stroke="#608cff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="50" d="
            M1,15.7L15.7,1c0,0,0,10.6,0,10.6l0-10.6H5.2"></path>

        </svg>
                </span></strong>
                <span class="dy_finraletters_product-rates__subtitle"></span>
            </div>
        </div>
        </a>`;
        this.htmlContents += StaticResourceListingItem;
      } else if (entry.componentType === 'StaticResourceLink') {
        const staticResourceLink = `<a class="dyfn_srl_product-rates__item dyfn_srl_static-resource__item dyfn_srl_static-resource__item--image js-showmore__item" href="${entry.linkUrl}" target="${entry.target ? entry.target : '_self'}">
          <div class="dyfn_srl_product-rates__content" tabindex="-1">
              <div class="dyfn_srl_static-resource__media dy__ar-250x190"><img src="${entry.imageUrl}?h=458&amp;la=en&amp;w=600&amp;hash=85D4210DFB32DE869A5DB3CA1A27ED05588DA077" alt="" class="loading" data-was-processed="true"></div>
              <div class="dyfn_srl_static-resource__copy">
                  <strong class="dyfn_srl_static-resource__title">
                      Advisor Sales Aids<span class="dyfn_srl_static-resource__icon">
                          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 16.7 16.7" enable-background="new 0 0 16.7 16.7" xml:space="preserve" role="presentation" focusable="false">
                          <path fill="#FFFFFF" fill-opacity="0" stroke="#8F2448" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="50" d="
                      M1,15.7L15.7,1c0,0,0,10.6,0,10.6l0-10.6H5.2"></path>



                  </svg>
                      </span>
                  </strong>
                  <span class="dyfn_srl_static-resource__subtitle"></span>
              </div>
          </div>
          </a>`;
        this.htmlContents += staticResourceLink;
      }
    });
    this.htmlContents += getReturnCaseEnd(comp.componentType);
    this.htmlContents += getReturnCaseEnd('fullWidthContainer');
  }

  displayAdvisorWholeSaler() {
    const _wholesalerInfo = this.wholesalerInfo;
    if (_wholesalerInfo.length > 0 && this.hasWholesalerInfo) {
      this.htmlContents += getReturnCase('fullWidthContainer');
      let advisorWholeSaler = `<div class="dy_wh_contact-wholesaler">
        <div class="dy_wh_section-heading dy_wh_contact-wholesaler__title" role="heading" aria-level="2">Contact your wholesalers</div>
        <ul class="dy_wh_contact-wholesaler__list">`;
      _wholesalerInfo.forEach((wholesaler: any) => {
        advisorWholeSaler += `<li class="dy_wh_contact-wholesaler__item">
            <div class="dy_wh_contact-wholesaler__info">              
              <div class="dy_wh_contact-wholesaler__name-contact">
                <div class="dy_wh_sub-heading dy_wh_contact-wholesaler__name">
                  ${wholesaler.firstName} ${wholesaler.lastName} &nbsp; | &nbsp; ${wholesaler.jobTitle} 
                </div>
                <div class="dy_wh_contact-wholesaler__contact">
                  <div class="dy_wh_contact-wholesaler__phone"><a href="tel:${wholesaler.phoneNumber}">${wholesaler.phoneNumber}</a></div>
                  <div class="dy_wh_contact-wholesaler__email"><a href="mailto:${wholesaler.emailAddress}">${wholesaler.emailAddress}</a></div>
                </div>
              </div>
            </div>
            <div class="dy_wh_contact-wholesaler__bio is-rte">
              <p></p>
            </div>
          </li>`;
      });
      advisorWholeSaler += `</ul>
      </div>`;
      this.htmlContents += advisorWholeSaler;
      this.htmlContents += getReturnCaseEnd('fullWidthContainer');
    } else {
      this.showdefaultWholesalers();
    }
  }

  showdefaultWholesalers() {
    this.htmlContents += getReturnCase('fullWidthContainer');
    const defaultWholesaler = `<div class="cw-subheading" style="text-align: left;font-family: 'Sul Sans'; font-size: 18px; font-weight: 400;">Please call 877.345.grow (4769), option 1</div>`;
    this.htmlContents += defaultWholesaler;
    this.htmlContents += getReturnCaseEnd('fullWidthContainer');
  }

  displayStaticResourceListingWithLimit(comp: any, limit: boolean): void {
    this.isshowMoreButton = true;
    const entriesToShow = limit ? (comp.entries.length <= 6 ? comp.entries : comp.entries.slice(0, 6)) : comp.entries;
    this.isshowMoreButton =
      comp.entries.every((entry: any) => entry.componentType === 'StaticResourceListing') &&
      comp.entries.length > 6 &&
      entriesToShow.length <= 6;
    entriesToShow.forEach((entry: any) => {
      if (entry.componentType === 'StaticResourceListing') {
        const StaticResourceListingItem = `<a class="dy_finraletters_product-rates__item js-showmore__item" href=${entry.link} target="_blank">
        <div class="dy_finraletters_product-rates__content" tabindex="-1">    
            <span class="dy_finraletters_icon-wrap dy_finraletters_product-rates__icon">
                <svg version="1.1" role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 25.1 31.6" enable-background="new 0 0 25.1 31.6" xml:space="preserve">
        <path fill="#FFFFFF" d="M25.1,28.6c0,2.3-1.9,3-2.9,3H2.9c-2.3,0-2.9-1.9-2.9-2.9V3c0-2.3,1.9-3,2.9-3h13.5L17,0.7l0,0l0,0l8,8.1
          L25.1,28.6z M17.1,2.4v3.9c0,0.3,0.1,1.8,1.8,1.8h3.9L17.1,2.4z M23.9,28.6V9.3l0,0h-5c-2.3,0-2.9-1.9-2.9-2.9V1.2H3
          C2.6,1.2,1.1,1.3,1.1,3v25.6c0,0.3,0.1,1.8,1.8,1.8h19.2C22.4,30.4,23.9,30.3,23.9,28.6L23.9,28.6z M21.5,20.7c0,0.2,0,0.6-0.6,0.9
          s-1.5,0.4-2.5,0.3c-1.3-0.2-2.5-0.7-3.5-1.4l-1,0.3L13,21l-0.4,0.1c-1.1,0.3-2.3,0.6-3.3,1C8.9,23,8.4,23.8,8,24.5
          c-0.2,0.3-1.4,2.1-2.7,2.1c-0.4,0-0.7-0.2-1-0.4c-0.3-0.3-0.4-0.6-0.4-1c0-0.8,0.7-1.6,1.3-2.1c0.8-0.9,1.9-1.5,3.2-2
          c0.5-1,0.9-2.1,1.3-3.1c0.3-0.8,0.6-1.7,1-2.5c-1-2.1-1.1-3.8-0.5-5.1c0.3-0.9,0.7-1.2,1.3-1.2c0.8,0,1.3,0.8,1.4,2.1
          c0.1,1.5-0.4,2.9-0.9,4.2c0.2,0.4,0.5,0.8,0.8,1.3c0.7,1,1.5,1.8,2.5,2.5c1.1-0.3,2-0.4,2.8-0.4c0.7,0,1.4,0.1,2,0.3
          C19.9,19.1,21.4,19.7,21.5,20.7L21.5,20.7z M7.5,22.8c-0.6,0.3-1.2,0.7-1.6,1.1C5.4,24.3,5,24.8,5,25.1c0,0.1,0,0.1,0.1,0.1
          c0.1,0.1,0.1,0.1,0.2,0.1c0.4,0,1.2-0.8,1.7-1.6C7.1,23.4,7.3,23.1,7.5,22.8L7.5,22.8z M11.7,11.3c0-0.3-0.1-0.6-0.2-0.9
          c-0.1,0.1-0.1,0.2-0.3,0.4c-0.4,0.9-0.3,2.1,0.1,3.1C11.5,13.1,11.7,12.2,11.7,11.3L11.7,11.3z M13.7,19.6c-0.9-0.8-1.7-1.7-2.4-2.8
          l-0.6,1.6c-0.3,0.7-0.6,1.5-0.9,2.2c0.8-0.2,1.6-0.4,2.4-0.7l0.4-0.1l0.9-0.2H13.7L13.7,19.6z M20.2,20.6c-0.2-0.2-0.5-0.3-0.7-0.4
          c-0.9-0.3-1.9-0.3-2.8-0.2c0.6,0.3,1.3,0.5,2,0.6C19.2,20.8,19.8,20.7,20.2,20.6L20.2,20.6z"></path>
        </svg>
            </span>    
            <div class="dy_finraletters_product-rates__copy">
                <strong class="dy_finraletters_product-rates__title">${entry.title}&nbsp;&nbsp;<span class="dy_finraletters_product-rates__linktype">PDF</span></strong>
                <span class="dy_finraletters_product-rates__subtitle">${entry?.summary}</span>
            </div>
        </div>
        </a>`;
        this.htmlContents += StaticResourceListingItem;
      }
    });
  }

  onClickShowMore() {
    this.isToShowList = false;
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.htmlContents = '';
    this.loadPageData();
  }

  getWholesalerInfo(): void {
    const payLoad: requestWholesalerInfoPlayload = {
      requestingSystem: 'FinPro',
      isEmulating: false,
      emulatingUserId: '',
    };
    this._wholeSalerService.fetchWholesalerInfo(payLoad).subscribe({
      next: (data: any) => {
        this.wholesalerInfo = data.wholesalerList;
        this.hasWholesalerInfo = this.wholesalerInfo?.length >= 1;
      },
      error: (error: string) => {
        this.errorMessage = error;
      },
    });
  }

  // Method to sanitize HTML content
  contentSanitizedHtml(_str: string): SafeHtml {
    const _str_refined = this.removeNewlines(_str);
    return this._sanitizer.bypassSecurityTrustHtml(_str_refined);
  }
  // Method to remove newlines
  removeNewlines(_str: string): string {
    return _str.replace(/\n/g, ''); // Replaces all newline characters
  }
  // Unsubscribe from the subscription
  ngOnDestroy(): void {
    this.seminarPageSubscription.unsubscribe();
    this.wholeSalerInfoSubscription.unsubscribe();
    this.routeSub?.unsubscribe();
  }
}
